import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/31_mountains/31_mountains"
 * Contains 1 texture(s)
 */
export class Mobile31MountainsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/31_mountains/31_mountains';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '31_mountains.jpg'
    ] as const;
}
